import { render, staticRenderFns } from "./snCatalog.vue?vue&type=template&id=2dc903f6&"
import script from "./snCatalog.vue?vue&type=script&lang=js&"
export * from "./snCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports